import * as translator from "../../../../../utils/translator";

type Props = {
  language: string | undefined;
  isEditMode: boolean;
  isSaving: boolean;
  isDeleting: boolean;
  canSave: boolean;
  onSave: () => void;
  onDelete: () => void;
};

const AddressFormFooter: React.FC<Props> = ({ language, isEditMode, isSaving, isDeleting, canSave, onSave, onDelete }) => {
  const saveDisabled = isSaving || !canSave;
  return (
    <div className="px-3 pb-4 shrink-0">
      <button
        onClick={onSave}
        disabled={saveDisabled}
        className={`flex items-center justify-center gap-2 w-full py-5 px-8 rounded-xl border-none text-white text-base font-medium font-poppins transition-colors duration-200 ${
          saveDisabled
            ? "bg-[#a0c4b0] cursor-not-allowed"
            : "linear-background-color-primary cursor-pointer"
        }`}
      >
        {isSaving
          ? (translator.translate(language, "shipping", "AddNewAddressModal/saving") || "Saving...")
          : (translator.translate(language, "shipping", "AddNewAddressModal/save") || "Save")}
      </button>

      {isEditMode && (
        <button
          onClick={onDelete}
          disabled={isDeleting}
          className={`flex items-center justify-center gap-2 w-full py-5 px-8 rounded-xl border-none bg-transparent text-[#cc0000] text-base font-medium font-poppins underline ${
            isDeleting ? "cursor-not-allowed" : "cursor-pointer"
          }`}
        >
          {isDeleting
            ? (translator.translate(language, "shipping", "AddNewAddressModal/deleting") || "Deleting...")
            : (translator.translate(language, "shipping", "AddNewAddressModal/delete") || "Delete")}
        </button>
      )}
    </div>
  );
};

export default AddressFormFooter;
